import { AlertAction, AlertKeys } from './actions';
import { Alert } from './types';

export type AlertsState = {
    alerts: Alert[];
};

export const initialState: AlertsState = {
    alerts: [] as Alert[],
};

const alertInArray = (alerts: Alert[], alert: Alert): boolean => {
    return alerts.find((currentAlert: Alert) => currentAlert.key === alert.key
        && currentAlert.info === alert.info,) !== undefined;
};

const removeAlert = (alerts: Alert[], alert: Alert): Alert[] => {
    return alerts.filter((currentAlert: Alert) => !(currentAlert.key === alert.key
            && currentAlert.info === alert.info),);
};

export const alertsReducer = (state = initialState, action: AlertAction): AlertsState => {
    switch (action.type) {
    case AlertKeys.PUSH_ALERT:
        if (!alertInArray(state.alerts, action.alert)) {
            return {
                alerts: [...state.alerts, action.alert],
            };
        }
        return state;
    case AlertKeys.REMOVE_ALERT:
        return {
            alerts: removeAlert(state.alerts, action.alert),
        };
    default:
        return state;
    }
};
